export const EMAIL = "gov@asquare.group";

export const NAV = [
  { label: "CAPABILITIES", href: "#capabilities" },
  { label: "WORK", href: "#work" },
  { label: "INTELLIGENCE", href: "#intelligence" },
  { label: "GROUP", href: "#group" },
  { label: "CONTACT", href: "#contact" },
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/220201/pexels-photo-220201.jpeg?auto=compress&cs=tinysrgb&w=1920",
  commandCenter:
    "https://images.pexels.com/photos/256219/pexels-photo-256219.jpeg?auto=compress&cs=tinysrgb&w=940",
  presenceCity:
    "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?w=1200&q=80",
};

export const CAPABILITIES = [
  {
    n: "01",
    title: "Government Intelligence",
    desc: "Decision systems, analytics and administrative AI for modern governance.",
    img: "https://images.pexels.com/photos/37425926/pexels-photo-37425926.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    n: "02",
    title: "Digital Infrastructure",
    desc: "Enterprise platforms, data architecture and mission-critical systems.",
    img: "https://images.pexels.com/photos/30521620/pexels-photo-30521620.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    n: "03",
    title: "Critical Systems",
    desc: "Airports, ports, urban infrastructure and integrated operating environments.",
    img: "https://images.pexels.com/photos/912050/pexels-photo-912050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    n: "04",
    title: "Strategic Execution",
    desc: "Public programs, institutional delivery and international collaboration.",
    img: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=940&q=80",
  },
];

export const SELECTED_WORK = [
  {
    tag: "AVIATION",
    title: "Intelligent Airports Framework",
    desc: "GOVXI launches a framework for intelligent airports — technology, operations and passenger experience across major airports.",
    img: "https://images.unsplash.com/photo-1556388158-158ea5ccacbd?w=940&q=80",
    href: "https://www.openpr.com/news/4576176/gov-x-ai-launches-framework-for-intelligent-airports",
  },
  {
    tag: "PUBLIC ADMINISTRATION",
    title: "GOVXI Programs",
    desc: "From digital governments to intelligent states — data-driven monitoring and administrative visibility at scale.",
    img: "https://images.pexels.com/photos/13105487/pexels-photo-13105487.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    href: "https://www.openpr.com/news/4494938/gov-ai-from-digital-governments-to-intelligent-states",
  },
  {
    tag: "CULTURAL DIPLOMACY",
    title: "Bharat Pavilion",
    desc: "Applying GOVXI to cultural diplomacy and civilizational statecraft on the global stage.",
    img: "https://images.unsplash.com/photo-1646998595781-c468f75dc4da?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBwYXZpbGlvbiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3OTI4NDAyODN8MA&ixlib=rb-4.1.0&q=85",
    href: "https://www.openpr.com/news/4597175/bharat-pavilion-applying-gov-x-ai-to-cultural-diplomacy",
  },
];

export const OFFICES = [
  {
    region: "SOUTH ASIA",
    lines: ["One Horizon Center", "Sector 43, Gurugram", "Haryana 122009, India"],
  },
  {
    region: "AMERICAS",
    lines: ["1 Pennsylvania Plaza", "New York, NY 10119", "United States"],
  },
  {
    region: "MIDDLE EAST",
    lines: ["Business Central Towers", "Al Sufouh 2, Dubai", "United Arab Emirates"],
  },
  {
    region: "ASIA PACIFIC",
    lines: ["3-chōme-2-2 Nakanoshima", "Kita Ward, Osaka 530-0005", "Japan"],
  },
];

export const ENGAGEMENTS = [
  "Government of India",
  "United Nations",
  "World Economic Forum",
  "G20",
  "BRICS",
  "OECD",
];

export const POLICY = [
  "AI Action Summit, France",
  "Global Partnership on AI",
  "G20 Summit, India",
  "NYC.Gov AI Action Plan",
];

export const FORUMS = [
  {
    label: "PANEL SESSION",
    title: "What Chess Teaches Humans When Machines Play Better",
    meta: "World Economic Forum Annual Meeting — January 21, 2026",
    href: "https://www.weforum.org/meetings/world-economic-forum-annual-meeting-2026",
  },
  {
    label: "ADVISORY COUNCIL",
    title: "BRICS Working Group",
    meta: "BRICS 2026",
    href: "https://www.brics2026.gov.in/",
  },
];

export const NEWSROOM = [
  {
    title: "Governing Intelligence: Building National Capability for the AI Era",
    href: "https://www.openpr.com/news/4595535/the-next-function-of-government-governing-intelligence",
  },
  {
    title: "GOVXI Launches Framework for Intelligent Airports",
    href: "https://www.openpr.com/news/4576176/gov-x-ai-launches-framework-for-intelligent-airports",
  },
  {
    title: "A-Square Group Outlines 2026-27 Investment Strategy in the Age of AI",
    href: "https://www.openpr.com/news/4392790/a-square-group-outlines-2026-27-investment-strategy-in-the-age",
  },
  {
    title: "Ankesh Arora Wants to Build the Intelligence Layer for Governments",
    href: "https://www.openpr.com/news/4625469/ankesh-arora-wants-to-build-the-intelligence-layer",
  },
  {
    title: "GOVXI: From Digital Governments to Intelligent States",
    href: "https://www.openpr.com/news/4494938/gov-ai-from-digital-governments-to-intelligent-states",
  },
  {
    title: "GOVXI for Cultural Diplomacy and Civilizational Statecraft",
    href: "https://www.openpr.com/news/4597175/bharat-pavilion-applying-gov-x-ai-to-cultural-diplomacy",
  },
];
